import {Component, Input, NgZone, OnInit, ViewChild} from '@angular/core';
import {IonicSlides, ModalController} from '@ionic/angular';
import {Router} from '@angular/router';
import {StorageManagerGatewayCapacitor} from '../../../../../adapters/real/app-services/storage-manager-gateway-capacitor';
import {SwiperComponent} from 'swiper/angular';
import SwiperCore, {Pagination} from 'swiper';

SwiperCore.use([Pagination, IonicSlides]);

@Component({
  selector: 'app-customer-welcome',
  templateUrl: './customer-welcome.component.html',
  styleUrls: ['./customer-welcome.component.scss'],
})
export class CustomerWelcomeComponent implements OnInit {
  @Input() roleChoiceMode = true;
  @Input() pageTitle: string;
  @ViewChild('swiper') swiperComponent: SwiperComponent;
  activeIndex = 0;

  constructor(private router: Router,
              private ngZone: NgZone,
              private modalCtrl: ModalController,
              private storageMgc: StorageManagerGatewayCapacitor) {}

  ionViewDidEnter() {
    this.swiperComponent.swiperRef.update();
  }

  ngOnInit() {}

  slideNext() {
    this.swiperComponent.swiperRef.slideNext(300);
  }

  slidePrev() {
    this.swiperComponent.swiperRef.slidePrev(300);
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

  goToCustomerQrCode() {
    this.modalCtrl.dismiss().then(isItDismissed => {
      if (isItDismissed) {
        this.storageMgc.remove('showCustomerWelcomeSlider').subscribe(isItRemoved => {
          if (isItRemoved) {  this.router.navigate(['/customer/qr-code']); }
        });
      }
    });
  }

  OnSlideChange() {
    this.ngZone.run(() => this.activeIndex = this.swiperComponent.swiperRef.activeIndex);
  }
}
